import React from 'react';
import { css } from '@emotion/react';
import { BaseLink } from 'views/components/atoms/BaseLink';
import { Typography } from 'views/components/atoms/Typography';
import { Color, FontSize, Radius } from 'views/constants';

// Button UI の種類が増えたらここに足していく
type StyleType = 'primary' | 'default';

const defaultStyle = {
  color: Color.C1,
  backgroundColor: Color.C6,
  borderColor: Color.C13,
  bold: true,
};

const primaryStyle = {
  color: Color.C6,
  backgroundColor: Color.C7,
  borderColor: Color.C8,
  bold: true,
};

const disabledStyle = {
  color: Color.C4,
  backgroundColor: Color.C5,
  borderColor: Color.C14,
  bold: true,
};

const styleMap: {
  [P in StyleType]: {
    color: Color;
    backgroundColor: Color;
    borderColor: Color;
    bold: boolean;
  };
} = {
  default: defaultStyle,
  primary: primaryStyle,
};

const baseStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  border-width: 1px;
  border-style: solid;
  border-radius: ${Radius.DEFAULT};
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
  }
  &:disabled:hover {
    cursor: initial;
  }
`;

type LinkButtonProps = {
  label: string | React.ReactNode;
  to: string;
  onClick?: () => void;
  style?: StyleType;
  disabled?: boolean;
  anotherTab?: boolean;
};

export const LinkButton: React.FC<LinkButtonProps> = ({
  label,
  to,
  onClick,
  style = 'default',
  disabled,
  anotherTab,
}) => {
  const { color, backgroundColor, borderColor, bold } = disabled
    ? disabledStyle
    : styleMap[style];

  const styles = css`
    ${baseStyle};
    color: ${color};
    background-color: ${backgroundColor};
    border-color: ${borderColor};
    bold: ${bold};
  `;

  return (
    <BaseLink
      to={to}
      style={styles}
      onClick={onClick}
      noDecoration
      block
      disabled={disabled}
      anotherTab={anotherTab}
    >
      <Typography size={FontSize.DEFAULT} color={color} bold>
        {label}
      </Typography>
    </BaseLink>
  );
};
